import React from "react";
import { useTranslation } from "react-i18next";
import type { SenderType } from "../utils/types";
import { SenderTypeRow } from "./SenderTypeRow";

type SenderTypePickerProps = {
  senderType: SenderType;
  onSenderTypeChange: (value: SenderType) => void;
};

export function SenderTypePicker({
  senderType,
  onSenderTypeChange,
}: SenderTypePickerProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <p
        id="messaging-sender-type-heading"
        className="text-xs font-medium uppercase tracking-wide text-muted-foreground"
      >
        {t("layout.messagingSettingsPage.senderTypeLabel")}
      </p>
      <div
        role="radiogroup"
        aria-labelledby="messaging-sender-type-heading"
        className="flex flex-col gap-1"
      >
        <SenderTypeRow
          selected={senderType === "hotel"}
          label={t("layout.messagingSettingsPage.senderTypeHotel")}
          onSelect={() => onSenderTypeChange("hotel")}
        />
        <SenderTypeRow
          selected={senderType === "staff"}
          label={t("layout.messagingSettingsPage.senderTypeStaff")}
          onSelect={() => onSenderTypeChange("staff")}
        />
      </div>
    </div>
  );
}
